module.exports = __webpack_public_path__ + "static/media/rotate.dda4a42d.svg";